import React, { useMemo, useState } from "react";
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { ChipFilter, filtroMultiplo } from "../../../../components/Tabella/ChipFilter";

const data_column = [

	{
		Header: 'Nome impianto',
		Footer: 'Nome impianto',
		accessor: 'impianto_nome',
	},
	{
		Header: 'Disponibilità',
		Footer: 'Disponibilità',
		accessor: 'impianto_date',
		disableGlobalFilter: true,
	},
	{
		Header: 'Sport',
		Footer: 'Sport',
		accessor: 'impianto_sport',
		disableGlobalFilter: true,
	},

	{
		Header: 'Stato impianto',
		Footer: 'Stato impianto',
		accessor: 'impianto_status',
		disableGlobalFilter: true,
		Cell: ({ value }) => {
			return (
				<div className="d-flex align-items-center">
					<i className={`fa fa-circle me-1 ${value.class}`}></i>
					{value.label}
				</div>
			)
		},
		disableFilters: true,
	},
];
const data_json = [

	{
		"impianto_nome": "Campo tennis terra rossa",
		"impianto_date": "Dal 04/04 al 31/10",
		"impianto_sport": "Tennis",
		"impianto_status": {
			"label": "Attivo",
			"class": "text-success"
		},
	},
	{
		"impianto_nome": "Campo padel blu (coperto)",
		"impianto_date": "Tutto l'anno",
		"impianto_sport": "Padel",
		"impianto_status": {
			"label": "Attivo",
			"class": "text-success"
		},
	},
	{
		"impianto_nome": "Campo padel rosso (coperto)",
		"impianto_date": "Tutto l'anno",
		"impianto_sport": "Padel",
		"impianto_status": {
			"label": "Attivo",
			"class": "text-success"
		},
	},
	{
		"impianto_nome": "Campo calcetto in erba",
		"impianto_date": "Dal 30/05 al 30/09",
		"impianto_sport": "Calcetto",
		"impianto_status": {
			"label": "Inattivo",
			"class": "text-primary"
		},
	},
	{
		"impianto_nome": "Campo calcetto in erba sintetica",
		"impianto_date": "Tutto l'anno",
		"impianto_sport": "Calcetto",
		"impianto_status": {
			"label": "In ristrutturazione",
			"class": "text-danger"
		},
	}
];

// Valori dei filtri a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Attivo', 'Inattivo', 'In ristrutturazione'];
const SPORT_OPTIONS = [...new Set(data_json.map((row) => row.impianto_sport).filter(Boolean))].sort();

const ListaImpianti = () => {
	const [sportFilter, setSportFilter] = useState('');
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	const filteredData = useMemo(
		() =>
			data_json.filter(
				(row) =>
					(!sportFilter || row.impianto_sport === sportFilter) &&
					filtroMultiplo(statoFilter, STATO_OPTIONS, row.impianto_status?.label),
			),
		[sportFilter, statoFilter],
	);

	return (
		<TabellaLista
			pageList={true}
			cardTitle={'Impianti'}
			hasSearch={true}
			searchPlaceholder={'Cerca per nome impianto'}
			hasFilter={false}
			filterControl={
				<div className="sid-chip-filters">
					<ChipFilter label="Sport" options={SPORT_OPTIONS} value={sportFilter} onChange={setSportFilter} asDropdown />
					<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
				</div>
			}
			hasAddMore={true}
			labelAddMore={'Nuovo impianto'}
			linkAddMore={'/struttura/prodotti/impianti/aggiungi'}
			data_column={data_column}
			data_json={filteredData}
		/>
	)
}

export default ListaImpianti
